// import api from '../api';

// Mocks
// import MOCK_DETAIL_HEADER from '../../mocks/mock-detail-header';
// import MOCK_DETAIL_TABS from '../../mocks/mock-detail-tabs';
import api from '../api';

/**
 * Get detail header data from an endpoint
 * @param {string} path - The path of the page
 * @param {string} contexte - The context
 * @returns {Promise<{
 * data: any | undefined,
 * error: Error | undefined,
 * isLoading: boolean,
 * isError: boolean
 * }>}
 */
export const getDetailHeader = async (path, contexte) => {
  /** @type {{data: any | undefined, error: Error | undefined, isLoading: boolean, isError: boolean}} */
  // const result = {
  //   data: undefined,
  //   error: undefined,
  //   isLoading: false,
  //   isError: false,
  // };

  const response = await api.get(`/detail-header?path=${path}&contexte=${contexte}`);
  return response.data;

  // Use mock for now
  // result.data = MOCK_DETAIL_HEADER;
  // // Simulate API delay
  // await new Promise((resolve) => {
  //   setTimeout(resolve, 1000);
  // });

  // return result;
};

/**
 * Get detail tabs data from an endpoint
 * @param {string} path - The path of the page
 * @param {string} contexte - The context
 * @returns {Promise<DetailTabsResponse>}
 */
export const getDetailTabs = async (path, contexte) => {
  const response = await api.get(`/detail-tabs?path=${path}&contexte=${contexte}`);
  return response.data;

  // Use mock for now
  // result.data = MOCK_DETAIL_TABS;
  // // Simulate API delay
  // await new Promise((resolve) => {
  //   setTimeout(resolve, 1000);
  // });

  // return result;
};

/**
 * Post detail tabs configuration
 * @param {string} path - The path of the page
 * @param {string} contexte - The context
 * @param {DetailTabsPostRequest} data - The tabs configuration to save
 * @returns {Promise<DetailTabsResponse>}
 */
export const postDetailTabs = async (path, contexte, data) => {
  const response = await api.post(`/detail-tabs?path=${path}&contexte=${contexte}`, data);
  return response.data;
};
